exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-b-tsx": () => import("./../../../src/pages/b.tsx" /* webpackChunkName: "component---src-pages-b-tsx" */),
  "component---src-pages-christmas-2026-tsx": () => import("./../../../src/pages/christmas-2026.tsx" /* webpackChunkName: "component---src-pages-christmas-2026-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */)
}

